import { type ReactElement } from 'react';
import { toast, Slide } from 'react-toastify';
import './AppVersionMessage.css';

/** Toast id used by the reference stale version toast implementation. */
export const STALE_VERSION_TOAST_ID = 'app-version-info-stale';

/** Shared className for stale version toasts across hosts. */
export const STALE_VERSION_TOAST_CLASS_NAME = 'Toastify__overwrite-info';

export interface StaleVersionToastCoreOptions {
  toastId: typeof STALE_VERSION_TOAST_ID;
  autoClose: false;
  closeOnClick: false;
}

/** Shared toast options reused by portal displayToast and default react-toastify path. */
export function getStaleVersionToastCoreOptions(): StaleVersionToastCoreOptions {
  return {
    toastId: STALE_VERSION_TOAST_ID,
    autoClose: false,
    closeOnClick: false,
  };
}

interface AppVersionMessageProps {
  onRefresh: () => void;
}

/**
 * Plain text message for a stale app version, rendered inline as text or in toast.
 * Hosts can reuse this inside their own toast stack.
 */
export function AppVersionMessage({
  onRefresh,
}: AppVersionMessageProps): ReactElement {
  return (
    <div>
      <span>A new version of this application is available.</span>
      <button
        type="button"
        className="app-version-message-refresh"
        onClick={onRefresh}
      >
        Refresh
      </button>
    </div>
  );
}

export interface ShowStaleVersionToastOptions {
  onRefresh: () => void;
}

/**
 * Default stale version toast for standalone hosts like notifier.
 * Uses react-toastify directly.
 */
export function showStaleVersionToast({
  onRefresh,
}: ShowStaleVersionToastOptions): void {
  if (toast.isActive(STALE_VERSION_TOAST_ID)) {
    return;
  }

  toast(<AppVersionMessage onRefresh={onRefresh} />, {
    ...getStaleVersionToastCoreOptions(),
    hideProgressBar: true,
    position: 'top-center',
    transition: Slide,
    closeButton: true,
    className: STALE_VERSION_TOAST_CLASS_NAME,
    bodyClassName: 'Toastify__overwrite-body',
  });
}
